import styles from './style.module.css';

// How a patient's use of psy starts, as numbered cards: the invitation,
// signing in and accepting, then keeping track together.
export function StartSteps({ steps }) {
  return (
    <ol className={ styles.steps }>
      { steps.map(function({ title, text }, index) {
        return (
          <li key={ title } className={ styles.step }>
            <span className={ styles.number } aria-hidden='true'>{ index + 1 }</span>

            <h3 className={ styles.title }>{ title }</h3>

            <p className={ styles.text }>{ text }</p>
          </li>
        );
      }) }
    </ol>
  );
}
